import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";

// styles
import "@/assets/style/style.scss";

// Globus UI KIT
import GlobusUI from "@globus/ui-kit";
import "@globus/ui-kit/dist/globus-ui-kit.css";
import "@globus/ui-kit/themes/globus.css";

// Directives
import { vClickOutside } from "@/composables/directives/clickOutside";
import tooltip from "@/composables/directives/tooltip";


const app = createApp(App);


// Register global directives
app.directive("click-outside", vClickOutside);
app.directive("tooltip", tooltip);

app.use(GlobusUI);
app.use(createPinia());
app.use(router);
app.mount("#app");

console.log(`Oracle build date ${process.env.VUE_APP_VERSION}`);
